import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { AlertFilter, AlertNotificationFilter } from "@shared/interfaces";

import { AlertReadDto, CreateAlertDto } from "../interfaces";

export default {
  getAlerts: (params: AlertFilter) => {
    return request(METHODS.GET, API.ALERT.GET_ALERTS)({ params });
  },
  getAlertNotifications: (params: AlertNotificationFilter) => {
    return request(METHODS.GET, API.ALERT.GET_ALERT_NOTIFICATIONS)({ params });
  },
  createAlert: (payload: CreateAlertDto) => request(METHODS.POST, API.ALERT.CREATE_ALERT)(payload),

  createUserAlert: (payload: CreateAlertDto & { id: number }) => {
    const { id, ...rest } = payload;
    return request(METHODS.POST, API.ALERT.CREATE_USER_ALERT(String(id)))(rest);
  },

  readAlertNotification: (payload: AlertReadDto) => {
    const { id, ...rest } = payload;
    return request(METHODS.POST, API.ALERT.READ_ALERT_NOTIFICATION(String(id)))(rest);
  },
};
